import axios from "axios";


export const getWhitelistedIP = async () => {
    const res = await axios.get("/api/Company/getWhitelistedIP");
    return res;
}


export const manageWhitelistIP = async (data) => {
    const res = await axios.post("/api/Company/manageWhitelistIP", data);
    return res;
}